export default {"src":"/_next/static/media/simplify.bb6f3267.svg","height":336,"width":560,"blurWidth":0,"blurHeight":0};